<template>
  <el-button :size="size" :type="type" icon="fas fa-search" @click="handleClick"></el-button>
</template>

<script>
export default {
  name: 'WHeaderSearchButton',
  props: {
    size: {
      type: String,
      default: 'small',
    },
    type: {
      type: String,
      default: 'default',
    },
  },
  methods: {
    handleClick(evt) {
      this.$emit('click', evt);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/button/HeaderSearchButton/HeaderSearchButton.vue